module.exports = __webpack_public_path__ + "assets/img/al11.82b68351.jpg";